import React, {Fragment} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableContainer from '@mui/material/TableContainer';
import {v4} from 'uuid'
import {s_chars} from "../_signals/s_chars";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char} from "../_signals/s_char";
import {IChar} from "../_interfaces/IChar";
import {s_app_rid, s_app_sl} from "../_signals/s_app";
import {Checkbox} from "@mui/material";
import {CharCopy, CharDelete, CharFieldsUpdate} from "../_api/BEChar";
import Button from "@mui/material/Button";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from "@mui/material/IconButton";

export default function Chars() {
    useSignals()

    const setCharFromChars = (char: IChar) => {
        s_char.value = char;
    }

    const setVisible = (cid: string, visible: boolean) => {
        CharFieldsUpdate(cid, [{k: 'visible', v: visible}]);
    }

    const copyChar = (cid: string) => {
        CharCopy(s_app_rid.value, cid)
    }

    const deleteChar = (cid: string) => {
        CharDelete(s_app_rid.value, cid)
    }

    const charRow = (row: IChar) => {

        return <Fragment key={v4()}>
            <TableRow key={v4()}>
                {!s_app_sl.value ?
                    <TableCell
                        style={{backgroundColor: row.schaden >= row.tot ? 'red' : row.schaden >= row.bew ? 'orange' : 'white'}}>
                        {row.pname ? row.pname : row.name}
                        {row.nsc ? ' (nsc)' : null}
                    </TableCell> :
                    <>
                        <TableCell
                            style={{backgroundColor: row.schaden >= row.tot ? 'red' : row.schaden >= row.bew ? 'orange' : 'white'}}>
                            {row.name} ({row.pname})
                        </TableCell>
                        <TableCell>{row.schaden}/{row.blutschaden}</TableCell>
                        <TableCell>{row.wund}/{row.bew}/{row.tot}</TableCell>
                        <TableCell>{row.wunden}/{row.blutwunden}</TableCell>
                        <TableCell>{row.karma}</TableCell>
                        <TableCell>
                            {row.nsc ? <>
                                <Checkbox defaultChecked={row.visible}
                                          onChange={(e) => setVisible(row.id, e.target.checked)}
                                />
                                <IconButton onClick={(e) => copyChar(row.id)}>
                                    <ContentCopyIcon/>
                                </IconButton>
                                <IconButton onClick={(e) => deleteChar(row.id)}>
                                    <DeleteIcon/>
                                </IconButton>
                            </> : null}
                        </TableCell>
                    </>}
            </TableRow>
        </Fragment>
    }

    return <Paper style={{marginBottom: 12, padding: 6}}>
        <h3 style={{margin: 4}}>Szene</h3>
        <TableContainer style={{maxHeight: 250}}>
            <Table stickyHeader className={'playerTable'} style={{width: '100%'}}>
                <TableHead key={v4()}>
                    <TableRow key={v4()}>
                        <TableCell></TableCell>
                        {s_app_sl.value ? <>
                            <TableCell>schaden</TableCell>
                            <TableCell>schwellen</TableCell>
                            <TableCell>wunden</TableCell>
                            <TableCell>karma</TableCell>
                            <TableCell></TableCell>
                        </> : null}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {Array.from(s_chars.value.entries())
                        .filter(([, char]) => !char.nsc)
                        .map(([, char]) => charRow(char))}
                    {Array.from(s_chars.value.entries())
                        .filter(([, char]) => char.nsc)
                        .map(([, char]) => charRow(char))}
                </TableBody>

            </Table>
        </TableContainer>
    </Paper>
}

